import { InputBox } from '../../../FormComponent';

export default function SmartInputEditor({
    inputBoxProps,
    readOnly,
    disabled,
    displayValue,
    placeholder,
    inputRef,
    onChange,
    onBlur,
    onPaste,
    onKeyDown,
}) {
    return (
        <InputBox
            {...inputBoxProps}
            readOnly={readOnly}
            disabled={disabled}
            value={displayValue}
            onChange={onChange}
            onBlur={onBlur}
            onPaste={onPaste}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            onFocus={(e) => {
                inputRef.current = e.target;
                inputBoxProps.onFocus?.(e);
            }}
            customActionOnChange={(e) => {
                if (!inputRef.current) {
                    inputRef.current = e.target;
                }
            }}
        />
    );
}
